import { Component, OnInit,  ChangeDetectorRef, ChangeDetectionStrategy, Input } from '@angular/core';
import { Router } from '@angular/router';
import { HpService } from 'projects/hp-api/src/lib/services/hp.service';
import { WizardHpBaseComponent } from 'projects/hp-api/src/lib/base/wizard/wizard-hp-base-component';
import { SimulateurComponent } from 'projects/hp-api/src/lib/simulateur/simulateur.component';
import { trigger, state, style, transition, animate } from '@angular/animations';



@Component({
  selector: 'app-menu-system',
  templateUrl: './menu-system.component.html',
  styleUrls: ['../../base/wizard/wizard-hp-base-component.scss', './menu-system.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('slideInOutRigth', [
      state('in', style({
        transform: 'translate3d(200%,0,0)'
      })),
      state('out', style({
        transform: 'translate3d(0, 0, 0)'
      })),
      transition('in => out', animate('400ms ease-in-out')),
      transition('out => in', animate('400ms ease-in-out'))
    ])
  ]
})
export class MenuSystemComponent extends WizardHpBaseComponent implements OnInit {

  @Input() hammer_active = false;
  @Input() vuId = false;
  @Input() viewExt_int = "0";
  @Input() hasInOrOutView :any;
  constructor(chgDetectorRef: ChangeDetectorRef, mainSimulateur: SimulateurComponent, hpService: HpService, router: Router) {
    super(chgDetectorRef, hpService, router);

  }

  ngOnInit(): void {
    super.ngOnInit();
    this.getHpService().emitDataChange();
    console.log( this.getHpService().getViewInsideAnswerId());

  }

  toggleViewInOut(event:any)
  {

      this.getSimulateur().toggleViewInOut(event)


  }
}
